/* eslint-disable no-case-declarations */
import {
  GET_ASSIGNMENT_EXTENSIONS_SUCCESS,
  GET_GLOBAL_INFO_SUCCESS,
  POST_GLOBAL_INFO_SUCCESS,
  UPDATE_GLOBAL_INFO_SUCCESS,
  UPDATE_GLOBAL_ASSIGNMENT_SUCCESS,
  GET_GLOBAL_PROPERTY_MANAGEMENT_SUCCESS,
  GET_GLOBAL_ASSIGNMENT_SUCCESS,
  POST_GLOBAL_ASSIGNMENT_SUCCESS
} from '../types/globalTypes';

const handleGlobalReducer = (draft, action) => {
  if (!draft.authorizationDetails[draft.currentAuthId]) draft.authorizationDetails[draft.currentAuthId] = {};
  if (draft.currentAuthId && !draft.authorizationDetails[draft.currentAuthId].global)
    draft.authorizationDetails[draft.currentAuthId].global = {};

  switch (action.type) {
    case GET_GLOBAL_INFO_SUCCESS:
    case UPDATE_GLOBAL_INFO_SUCCESS:
    case POST_GLOBAL_INFO_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].global = action.response;
      break;

    case POST_GLOBAL_ASSIGNMENT_SUCCESS:
    case UPDATE_GLOBAL_ASSIGNMENT_SUCCESS:
    case GET_GLOBAL_ASSIGNMENT_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].global.globalInfo = action.response;
      break;

    case GET_ASSIGNMENT_EXTENSIONS_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].global.globalExtensions = action.response;
      break;

    // case UPDATE_GLOBAL_ASSIGNMENT_SUCCESS:
    //   draft.authorizationDetails[draft.currentAuthId].global.globalAssignment = action.response;
    //   break;

    case GET_GLOBAL_PROPERTY_MANAGEMENT_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].global.propertyManagementInfo = action.response;
      break;

    default:
      break;
  }

  return draft;
};

export default handleGlobalReducer;
